import React from 'react';
import {
  Wrapper,
  StyledPopCollectionContainer,
  StyledPopContentContainer
} from './ProofPointStackedCollectionRebrand.styled';
import Typography from '@latitude/typography';
import Button from '@latitude/button-rebrand';
import ProofPointStackedRebrand from '../ProofPointStackedRebrand/ProofPointStackedRebrand';

const COMPONENT_ID = 'proof-point-stacked-collection-rebrand';

const ProofPointStackedCollectionRebrand = props => {
  const { title, proofPoints, trackingId, ...rest } = props.data;

  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;

  return (
    <Wrapper className={componentIdentifier} {...rest}>
    <StyledPopCollectionContainer>
      <Typography.H4>
        {title}
      </Typography.H4>
      <StyledPopContentContainer
        className={`${componentIdentifier}-content-container`}
      >
        {proofPoints?.map((point, index) => (
          <ProofPointStackedRebrand
            key={index}
            point={point}
            numOfPoints={proofPoints?.length}
          />
        ))}
      </StyledPopContentContainer>
    </StyledPopCollectionContainer>
    </Wrapper>
  );
};

export default ProofPointStackedCollectionRebrand;
